import IRequestsFilter from "interfaces/IRequestFilter";

const initialRequestsFilter = () : IRequestsFilter => ({
  searchText: ""
});

export { initialRequestsFilter };
